import React, { useState } from 'react';
import PageHeader from "../../components/PageHeader";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { customTableStyles } from "../../utils";
// import AlertCreateModal from './Create';
// import AlertEditModal from './Edit';
// import ViewModal from './View';
import ViewModal from './ViewModal';
import TaskCreateModal from './CreateModal';
import TaskEditModal from './EditModal';
import { Button } from "react-bootstrap";

const TasksPage = () => {
    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isView, setIsView] = useState(false)
    const columns = [
        {
            name: 'Title',
            selector: row => row.title,
            sortable: true,
        },
        {
            name: 'Assign To',
            selector: row => row.assignTo,
            sortable: true,
        },
        {
            name: 'Due Date',
            selector: row => row.dueDate,
            sortable: true,
        },    
        {
            name: 'Added By',
            sortable: true,
            cell: (row) => (
                <span className='badge bg-info'>{row.addedBy}</span>
            ),
        },
        {
            name: 'Updated By',
            // selector: row => row.updatedBy,
            cell: (row) => (
                <span className='badge bg-info'>{row.updatedBy}</span>
            ),
            sortable: true,
        },
        {
            name: 'Created At',
            selector: row => row.createdAt,
            sortable: true,
        },
        {
            name: 'Updated At',
            selector: row => row.updatedAt,
            sortable: true,
        },
        {
            name: 'Actions',
            cell: (row, i) => {
                return (
                    <>
                        <div className="hstack gap-1 fs-1">
                            <Button
                                aria-label="View"
                                onClick={() => setIsView(true)}
                                className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                            >
                                <i className="ri-eye-line" />
                            </Button>
                            <Button
                                aria-label="Edit"
                                onClick={() => setIsEdit(true)}
                                className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                            >
                                <i className="ri-edit-line" />
                            </Button>
                            <a
                                aria-label="Delete"
                                href="javascript:void(0);"
                                className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                            >
                                <i className="ri-delete-bin-7-line" />
                            </a>
                        </div>
                    </>
                )
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];
    const data = [
        {
            title: 'Task 1',
            assignTo: 'User 1',
            dueDate: '2024-03-15',
            addedBy: 'Admin A',
            updatedBy: 'User B',
            createdAt: '2024-03-01T12:00:00',
            updatedAt: '2024-03-10T09:30:00',
        },
        {
            title: 'Task 2',
            assignTo: 'User 2',
            dueDate: '2024-03-18',
            addedBy: 'Admin B',
            updatedBy: 'User C',
            createdAt: '2024-03-02T10:30:00',
            updatedAt: '2024-03-12T11:45:00',
        },
        {
            title: 'Task 3',
            assignTo: 'User 3',
            dueDate: '2024-03-20',
            addedBy: 'Admin A',
            updatedBy: 'User D',
            createdAt: '2024-03-05T14:20:00',
            updatedAt: '2024-03-15T09:10:00',
        },
        {
            title: 'Task 4',
            assignTo: 'User 4',
            dueDate: '2024-03-22',
            addedBy: 'Admin C',
            updatedBy: 'User E',
            createdAt: '2024-03-07T11:30:00',
            updatedAt: '2024-03-18T10:25:00',
        },
        {
            title: 'Task 5',
            assignTo: 'User 5',
            dueDate: '2024-03-25',
            addedBy: 'Admin B',
            updatedBy: 'User F',
            createdAt: '2024-03-10T09:40:00',
            updatedAt: '2024-03-20T11:55:00',
        },
        {
            title: 'Task 6',
            assignTo: 'User 6',
            dueDate: '2024-03-28',
            addedBy: 'Admin D',
            updatedBy: 'User G',
            createdAt: '2024-03-12T15:30:00',
            updatedAt: '2024-03-22T14:20:00',
        },
        {
            title: 'Task 7',
            assignTo: 'User 7',
            dueDate: '2024-03-30',
            addedBy: 'Admin C',
            updatedBy: 'User H',
            createdAt: '2024-03-15T08:45:00',
            updatedAt: '2024-03-25T17:30:00',
        },
        {
            title: 'Task 8',
            assignTo: 'User 8',
            dueDate: '2024-04-02',
            addedBy: 'Admin A',
            updatedBy: 'User I',
            createdAt: '2024-03-18T10:00:00',
            updatedAt: '2024-03-28T12:20:00',
        },
        {
            title: 'Task 9',
            assignTo: 'User 9',
            dueDate: '2024-04-05',
            addedBy: 'Admin D',
            updatedBy: 'User J',
            createdAt: '2024-03-20T13:20:00',
            updatedAt: '2024-03-30T09:45:00',
        },
        {
            title: 'Task 10',
            assignTo: 'User 10',
            dueDate: '2024-04-08',
            addedBy: 'Admin B',
            updatedBy: 'User K',
            createdAt: '2024-03-22T09:30:00',
            updatedAt: '2024-04-01T10:55:00',
        },
    ];
    
    return (
        <>
            <PageHeader name="Tasks" />
            <div className="main-container container-fluid">
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0 justify-content-between">
                                    <div className="col-auto p-0 d-flex">
                                        <Button className="btn btn-primary" onClick={() => setIsShow(true)}>
                                            Create Task
                                        </Button>
                                    </div>
                                    <div className="col-lg-3 col-5 p-0">
                                        <div className="input-group m-0">
                                            <span
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line" />
                                            </span>
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <DataTable
                                    columns={columns}
                                    data={data}
                                    customStyles={customTableStyles}
                                    pagination={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <TaskCreateModal
                show={isShow}
                handleClose={() => setIsShow(false)}
            />
            <TaskEditModal
                show={isEdit}
                handleClose={() => setIsEdit(false)}
            />
            <ViewModal
                show={isView}
                handleClose={() => setIsView(false)}
            />
        </>
    );
};

export default TasksPage;